module.exports = __webpack_public_path__ + "static/media/Jquery.0fb1be87.svg";